import { useLoadingState, useMonkTheme } from '@monkvision/common';
import { Button } from '@monkvision/common-ui-web';
import { useMonitoring } from '@monkvision/monitoring';
import { useTranslation } from 'react-i18next';
import { DebouncedState } from 'use-debounce';
import { useTeslaPdfGenerator } from '../../../hooks';
import { TeslaInspectionStatus } from '../../../hooks/useTeslaInspectionList/types';
import { styles } from './GeneratePDFButton.styles';

export interface GeneratePDFButtonProps {
  inspectionId: string;
  onStatusChange: DebouncedState<(inspectionId: string, value: TeslaInspectionStatus) => void>;
}

export function GeneratePDFButton({ inspectionId, onStatusChange }: GeneratePDFButtonProps) {
  const loading = useLoadingState();
  const { handleError } = useMonitoring();
  const { palette } = useMonkTheme();
  const { t } = useTranslation();
  const { generateAndDownloadPdf } = useTeslaPdfGenerator({ openInNewTab: false });

  const handleGeneratePdf = async () => {
    loading.start();
    try {
      await generateAndDownloadPdf(inspectionId);
      onStatusChange(inspectionId, TeslaInspectionStatus.PDF_SENT);
      loading.onSuccess();
    } catch (err) {
      handleError(err);
      loading.onError(err);
    }
  };

  return (
    <Button
      onClick={handleGeneratePdf}
      loading={loading}
      variant='outline'
      primaryColor={palette.text.white}
      secondaryColor={palette.secondary.xdark}
      style={styles['pdfButton']}
    >
      {t('inspectionReview.generatePdf').toUpperCase()}
    </Button>
  );
}
